module.exports = ".image-writer{\r\n    height: 80px !important;\r\n    width: 250px !important;\r\n    border-radius: 50px !important;\r\n    -o-object-fit: fill;\r\n    object-fit: fill;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/our-writters/our-writters.component.css
// module id = ./src/app/our-writters/our-writters.component.css
// module chunks = main